import { Autocomplete, Chip, TextField } from "@mui/material";
import type { SyntheticEvent } from "react";
import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";

export interface ServiceInstancesFilterProps {
  options: string[];
  label?: string;
}

export function ServiceInstancesFilter({
  options,
  label = "Service Instances",
}: ServiceInstancesFilterProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const selected = useMemo(() => {
    const raw = searchParams.get("service_instances");
    return raw
      ? raw
          .split(",")
          .map((s) => s.trim())
          .filter((s) => s.length > 0)
      : [];
  }, [searchParams]);

  const handleChange = (_event: SyntheticEvent, value: string[]) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (value.length === 0) {
          next.delete("service_instances");
        } else {
          next.set("service_instances", value.join(","));
        }
        return next;
      },
      { replace: true },
    );
  };

  return (
    <Autocomplete
      multiple
      options={options}
      value={selected}
      onChange={handleChange}
      size="small"
      renderTags={(value: readonly string[], getTagProps) =>
        value.map((option: string, index: number) => (
          <Chip
            {...getTagProps({ index })}
            key={option}
            label={option}
            size="small"
            className="om-text-mono"
          />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select instances" size="small" />
      )}
    />
  );
}
